import "./page-terms-privacy.scss";
import "sticky-kit/dist/sticky-kit";
import "../../js/core";
import Collapse from "bootstrap/js/src/collapse";
import { stickySidebar } from "../../js/sticky-sidebar";
import "../../../assets/src/eos/js/scroll-to-anchor";

// Stiky function
stickySidebar(134);

$(document).ready(function () {
  // Collapse close
  $(".accordion-button.less").on("click", function () {
    let closeTargetCollapse = $(this).data("bs-target");
    console.log(closeTargetCollapse);
    $(closeTargetCollapse).collapse("hide");
  });

  $("#collapseOne").on("hidden.bs.collapse", function () {
    $(".js-fixed-inner").trigger("sticky_kit:detach");
    stickySidebar(134);
  });

  $("#collapseOne").on("shown.bs.collapse", function () {
    $(document.body).trigger("sticky_kit:recalc");
  });
});
